import { IonAccordionGroup, IonAccordion, IonList, IonActionSheet, IonRouterLink, IonSpinner, IonApp, IonContent, IonPage, IonHeader, IonTitle, IonButtons, IonModal, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { remove, chevronForward, checkmark, closeOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState, useEffect }  from 'react';

import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr, GetLanguage } from "../language/Language";

import '../pages/Main.css'; 
import '../pages/ChatMsg.css';

interface ItemSelectorProp {
    title : string,
    isOpen : any,
    onDidDismiss : any,
    onSelect : any,
    items : string[],
    selected : number
};

const ItemSelector : React.FC<ItemSelectorProp> = ({ title, isOpen, onDidDismiss, onSelect, items, selected }) => {
    
    // click on item
    const doSelect = (index : number) => {
        onSelect(index);
        onDidDismiss();
    }

    return (
         <IonModal
            isOpen={isOpen}
            initialBreakpoint={ 0.8 }
            onDidDismiss={onDidDismiss}>
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonTitle><h5>{ title }</h5></IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={onDidDismiss}>
                            <IonIcon icon={closeOutline} size="large"/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent>
                    <IonList className="list-80">
                    {
                        items.map((s, index) => (
                        <IonItem href="#" key={index} lines="full" onClick={ ()=> doSelect(index) }>
                            
                            {
                                index == selected ?
                            <IonLabel><b>{ s }</b></IonLabel>
                                :
                            <IonLabel>{ s }</IonLabel>
                            }

                            {
                                index == selected ?
                            <IonIcon slot="end" icon={checkmark} />
                                :
                            <div/>
                            }
                        </IonItem>
                        ))
                    }
                    </IonList>
                </IonContent>
            </div>
        </IonModal>
    );
};
  
export default ItemSelector;